module.exports = __webpack_public_path__ + "static/img/copyright5.82e240cc.png";